import './App.css';
import Home from './pages/home/Home';
import Register from './pages/register/Register';
import { Routes, Route } from "react-router-dom";
import Login from './pages/login/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Footer from './components/footer/Footer';
import Orders from './pages/orders/Orders';
import { useSelector } from 'react-redux';
import Product from './pages/products/Product';
import CreateProduct from './pages/products/create/CreateProduct';
import User from './pages/users/User';
import Settings from './pages/settings/Settings';
import EditProduct from './pages/products/edit/EditProduct';


function App() {
  //const {user} = useContext(Context);
  const user = useSelector((state) => state.user.currentUser);
  return (
    <div className="App">
      {/* <Topbar /> */}

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={user ? <Dashboard /> : <Login />} />

          <Route path="/register" element={<Register />} />

          <Route path="/dashboard" element={user ? <Dashboard /> : <Login />} />
          <Route path="/orders" element={user ? <Orders /> : <Login />} />
          <Route path="/products" element={user ? <Product /> : <Login />} />
          <Route path="/createProduct" element={user ? <CreateProduct /> : <Login />} />
          <Route path="/edit-product/:id" element={user ? <EditProduct /> : <Login />} />
          <Route path="/users" element={user ? <User /> : <Login />} />
          <Route path="/settings" element={user ? <Settings /> : <Login />} />

        </Routes>
        <Footer /> 
      </main>

    </div>
  );
}


export default App;
